module.exports = __webpack_public_path__ + "4df9ec7c700810ec1a9d743bbdc7079c.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/205.png
// module id = 1775
// module chunks = 2